import React from "react";

export const Logo = ({ className = "" }) => {
    return (
        <a
            href="/"
            data-testid="plenum-logo"
            className={`inline-flex items-baseline gap-[5px] font-medium text-[28px] sm:text-[32px] leading-none tracking-[-0.045em] ${className}`}
            style={{ color: "var(--plenum-accent-2)" }}
        >
            <span>Plenum</span>
            <span
                aria-hidden="true"
                className="inline-block w-[7px] h-[7px] rounded-full translate-y-[-2px]"
                style={{ backgroundColor: "var(--plenum-accent-2)" }}
            />
            <span
                aria-label="Schweiz"
                role="img"
                className="ml-[10px] text-[36px] sm:text-[42px] leading-none translate-y-[2px]"
                style={{
                    fontFamily:
                        '"Apple Color Emoji","Segoe UI Emoji","Noto Color Emoji",sans-serif',
                }}
                data-testid="plenum-logo-flag"
            >
                🇨🇭
            </span>
        </a>
    );
};

export default Logo;
